export var ReportType;
(function (ReportType) {
    ReportType["Confirmed"] = "Confirmed";
    ReportType["Deaths"] = "Deaths";
    ReportType["Recovered"] = "Recovered";
})(ReportType || (ReportType = {}));
